import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useEffect } from "react";
import BlockUiOverlay from "components/Expense/BlockUiOverlay";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { saveAs } from "file-saver";
import pdfimg from "assets/img/pdf.png";
import pptimg from "assets/img/ppt.png";
import excelimg from "assets/img/xls.png";
import notpadimg from "assets/img/notepad.png";
import arrorimg from "assets/img/arrow.png";
import eyeimg from "assets/img/Viewicon.png";
import Swal from "sweetalert2";

const GetDocumentsbyCategory = (props) => {
  const documentimg = "https://cdn-icons-png.flaticon.com/128/2991/2991108.png";
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  //const location = useLocation();
  // Extract documentId from location state
  const { documentCategory } = props.location.state;
  const documentCategoryId = documentCategory.documentCategoryId;
  const documentType = documentCategory.name;

  const fetchItems = async () => {
    setLoading(true);
    fetch(
      `${BASE_URL}/api/Document/GetDocumentsbyCategoryId?categoryId=${documentCategoryId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setDocuments(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchItems();
  }, []);

  //here is the code of convert date in dd/mm/yyyy formate
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad single digits with leading zero
    const formattedDay = String(day).padStart(2, "0");
    const formattedMonth = String(month).padStart(2, "0");

    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  // Function to check if the file path corresponds to an image
  const isImage = (filePath) => {
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"]; // Add more image extensions if needed
    const extension = filePath.substring(filePath.lastIndexOf(".")); // Get the file extension

    return imageExtensions.includes(extension.toLowerCase());
  };

  //get image according file name extension
  const getDocumentImageSrc = (filePath) => {
    const extension = filePath
      .substring(filePath.lastIndexOf("."))
      .toLowerCase();
    switch (extension) {
      case ".pdf":
        return pdfimg; // Assuming pdfimg is the image source for PDF files
      case ".doc":
      case ".docx":
        return documentimg; // Assuming wordimg is the image source for Word files
      case ".xls":
      case ".xlsx":
        return excelimg; // Assuming excelimg is the image source for Excel files
      case ".ppt":
      case ".pptx":
        return pptimg; // Assuming pptimg is the image source for PowerPoint files
      case ".txt":
        return notpadimg;
      default:
        return documentimg; // Default image source for other document types
    }
  };

  // here is the code of get proper file name using filePath
  const getDocumentName = (filePath) => {
    // Find the index of the underscore (_) character after 'wwwroot/Documents\'
    const underscoreIndex = filePath.indexOf(
      "_",
      filePath.indexOf("wwwroot/Documents\\")
    );

    // Extract the document name from the file path
    const fileName = filePath.substring(underscoreIndex + 1);

    return fileName;
  };

  //here is the code of download all document one by one
  // here use file server for download all files
  // const handleDownloadAll = async () => {
  //     Swal.fire{}
  //     try {
  //         for (const document of documents) {
  //             if (document.filePath) {
  //                 const filePaths = document.filePath.split(',');
  //                 for (const filePath of filePaths) {
  //                     const url = `${BASE_URL}${filePath.replace('wwwroot', '')}`;
  //                     const response = await fetch(url);
  //                     const blob = await response.blob();
  //                     const fileName = `document_${documents.indexOf(document)}_${filePaths.indexOf(filePath)}`;

  //                     // Use FileSaver.js to save the blob as a file
  //                     saveAs(blob, fileName);
  //                 }
  //             }
  //         }
  //     } catch (error) {
  //         console.error('Error downloading documents:', error);
  //     }
  // };

  //here is the code of the download all documents
  const handleDownloadAll = async () => {
    // Show SweetAlert confirmation dialog
    const confirmationResult = await Swal.fire({
      title: "Download All Documents",
      text: "Are you sure you want to download all documents?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, download all",
      cancelButtonText: "No, cancel",
    });

    // If user confirms, proceed with download
    if (confirmationResult.isConfirmed) {
      try {
        for (const document of documents) {
          if (document.filePath) {
            const filePaths = document.filePath.split(",");
            for (const filePath of filePaths) {
              const url = `${BASE_URL}${filePath.replace("wwwroot", "")}`;
              const response = await fetch(url);
              const blob = await response.blob();
              const fileName = `document_${documents.indexOf(
                document
              )}_${filePaths.indexOf(filePath)}`;

              // Use FileSaver.js to save the blob as a file
              saveAs(blob, fileName);
            }
          }
        }
      } catch (error) {
        console.error("Error downloading documents:", error);
        // Show error message if download fails
        Swal.fire({
          title: "Error",
          text: "Failed to download documents. Please try again later.",
          icon: "error",
        });
      }
    }
  };

  //here is the code of the print document or image file
  const handlePrint = async (fileUrl) => {
    try {
      // Check the file extension
      const fileExtension = fileUrl.split(".").pop().toLowerCase();

      // If the file extension is for Word, PowerPoint, Excel files, download directly
      if (
        ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(fileExtension)
      ) {
        window.open(fileUrl, "_blank");
        return;
      } else if (["pdf"].includes(fileExtension)) {
        try {
          // Fetch the PDF file
          const response = await fetch(fileUrl);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);

          // Open the PDF file in a new window
          const printWindow = window.open(url, "_blank");

          // After a short delay, trigger the print operation
          setTimeout(() => {
            printWindow.print();
          }, 1000); // Adjust the delay as needed
        } catch (error) {
          console.error("Error handling PDF file:", error);
        }
        return;
      } else if (["txt"].includes(fileExtension)) {
        // For text files, fetch content and print
        const response = await fetch(fileUrl);
        const text = await response.text();

        // Create a textarea to display text content
        const textarea = document.createElement("textarea");
        textarea.style.cssText =
          "width: 100%; height: 100%; border: none; resize: none; overflow: auto;";
        textarea.value = text;

        // Open a print window and append textarea
        const printWindow = window.open("", "_blank");
        printWindow.document.body.appendChild(textarea);
        printWindow.onload = () => {
          printWindow.print();
        };
        return;
      }

      // For other file types (images), fetch the file data
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          // Create a new window for printing
          const printWindow = window.open("", "_blank");

          // Create a canvas element to draw the image
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          // Calculate the width and height for A4 size paper (approximately 595px x 842px)
          const aspectRatio = img.width / img.height;
          const maxWidth = 595;
          const maxHeight = 842;
          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            width = maxWidth;
            height = width / aspectRatio;
          }
          if (height > maxHeight) {
            height = maxHeight;
            width = height * aspectRatio;
          }

          // Set canvas dimensions
          canvas.width = width;
          canvas.height = height;

          // Draw the image onto the canvas
          context.drawImage(img, 0, 0, width, height);

          // Append the canvas to the print window and trigger print
          printWindow.document.body.appendChild(canvas);
          printWindow.onload = () => {
            printWindow.print();
          };
        };
      };
    } catch (error) {
      console.error("Error handling file:", error);
    }
  };

  //here is the code of the view document or image file
  const handleviewdoc = (fileUrl, event) => {
    // Prevent the default click behavior
    event.preventDefault();

    // Open the file URL in a new tab
    window.open(fileUrl, "_blank");
  };

  //download document one by one
  const handleDownload = async (fileUrl) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "");

      // Append the anchor element to the body
      document.body.appendChild(link);

      // Trigger the click event
      link.click();

      // Remove the anchor element and revoke the URL
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const printicon =
    "https://icons.iconarchive.com/icons/avosoft/warm-toolbar/256/print-icon.png";

  return (
    <>
      <Navbar />
      <div className="cust-div">
        <div className="container mx-auto mt-8 p-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl  uppercase font-bold">
              Documents of "<span>{documentType}</span>"
            </h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                style={{ paddingTop: "6px", paddingBottom: "10px" }}
                onClick={() => history.push("/getAllDocumentCategory")}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To Documents Category"
                ></i>
              </button>

              <button className="buttonDownload" onClick={handleDownloadAll}>
                Download All
              </button>
            </div>
          </div>

          <div className="flex flex-wrap">
            {documents.length > 0 ? (
              <>
                {documents.map(
                  (document, documentIndex) =>
                    document.filePath && (
                      <React.Fragment key={documentIndex}>
                        {document.filePath
                          .split(",")
                          .map((filePath, filePathIndex) => (
                            <div key={filePathIndex} style={{ margin: "8px" }}>
                              {/* First data */}
                              {isImage(filePath) ? (
                                <>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      width: "100px",
                                    }}
                                  >
                                    <a
                                      href={
                                        BASE_URL +
                                        filePath.replace("wwwroot", "")
                                      }
                                      download={`document_${documentIndex}_${filePathIndex}.jpg`} // Set the filename for downloaded file
                                      target="_blank" // Open in a new tab
                                    >
                                      <img
                                        src={
                                          BASE_URL +
                                          filePath.replace("wwwroot", "")
                                        }
                                        alt={`Image ${documentIndex}_${filePathIndex}`}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          borderRadius: "5px",
                                          boxShadow:
                                            "0 0 10px rgba(0, 0, 0, 0.1)",
                                        }}
                                        title={getDocumentName(filePath)}
                                      />
                                    </a>
                                    {/* <span style={{ marginTop: '5px' }}>{getDocumentName(filePath)}</span><br/> */}
                                    <span
                                      style={{
                                        textAlign: "center",
                                        marginTop: "5px",
                                        marginBottom: "0",
                                      }}
                                      title={getDocumentName(filePath)}
                                    >
                                      {getDocumentName(filePath).length > 19
                                        ? `${getDocumentName(
                                            filePath
                                          ).substring(0, 10)}...`
                                        : getDocumentName(filePath)}
                                    </span>
                                    <br />
                                    <span>
                                      {formatDate(document.createdOn)}
                                    </span>
                                    <div style={{ marginTop: "5px" }}>
                                      <button
                                        onClick={() =>
                                          handlePrint(
                                            BASE_URL +
                                              filePath.replace("wwwroot", "")
                                          )
                                        }
                                      >
                                        <img
                                          src={printicon}
                                          alt="print"
                                          style={{ maxWidth: "25px" }}
                                        ></img>
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleDownload(
                                            BASE_URL +
                                              filePath.replace("wwwroot", "")
                                          )
                                        }
                                      >
                                        <img
                                          src={arrorimg}
                                          alt="print"
                                          style={{ maxWidth: "25px" }}
                                        ></img>
                                      </button>
                                      <button
                                        onClick={(event) =>
                                          handleviewdoc(
                                            BASE_URL +
                                              filePath.replace("wwwroot", ""),
                                            event
                                          )
                                        }
                                      >
                                        <img
                                          src={eyeimg}
                                          alt="print"
                                          style={{ maxWidth: "25px" }}
                                        ></img>
                                      </button>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      width: "100px",
                                    }}
                                  >
                                    <a
                                      href={
                                        BASE_URL +
                                        filePath.replace("wwwroot", "")
                                      }
                                      target="_blank" // Open in a new tab
                                      rel="noopener noreferrer" // Security measure for target="_blank"
                                    >
                                      <img
                                        src={getDocumentImageSrc(filePath)}
                                        title={getDocumentName(filePath)}
                                        alt={`Document ${documentIndex}_${filePathIndex}`}
                                        style={{ maxWidth: "100px" }}
                                      />
                                    </a>
                                    <span
                                      style={{
                                        textAlign: "center",
                                        marginTop: "5px",
                                        marginBottom: "0",
                                      }}
                                      title={getDocumentName(filePath)}
                                    >
                                      {getDocumentName(filePath).length > 19
                                        ? `${getDocumentName(
                                            filePath
                                          ).substring(0, 10)}...`
                                        : getDocumentName(filePath)}
                                    </span>
                                    <br />
                                    <span>
                                      {formatDate(document.createdOn)}
                                    </span>
                                    <br />
                                    {/* <button onClick={(event) => handlePrint(`${BASE_URL}${filePath.replace('wwwroot', '')}`, event)}>
                                                            <img src={printicon} alt='print' style={{ maxWidth: '25px' }}></img>
                                                        </button> */}
                                    <button
                                      onClick={() =>
                                        handlePrint(
                                          BASE_URL +
                                            filePath.replace("wwwroot", "")
                                        )
                                      }
                                    >
                                      <img
                                        src={printicon}
                                        alt="print"
                                        style={{ maxWidth: "25px" }}
                                      ></img>
                                    </button>

                                    <button
                                      onClick={(event) =>
                                        handleDownload(
                                          `${BASE_URL}${filePath.replace(
                                            "wwwroot",
                                            ""
                                          )}`,
                                          event
                                        )
                                      }
                                    >
                                      <img
                                        src={arrorimg}
                                        alt="print"
                                        style={{ maxWidth: "25px" }}
                                      ></img>
                                    </button>
                                    <button
                                      onClick={(event) =>
                                        handleviewdoc(
                                          `${BASE_URL}${filePath.replace(
                                            "wwwroot",
                                            ""
                                          )}`,
                                          event
                                        )
                                      }
                                    >
                                      <img
                                        src={eyeimg}
                                        alt="print"
                                        style={{ maxWidth: "25px" }}
                                      ></img>
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                      </React.Fragment>
                    )
                )}
              </>
            ) : (
              <>
                <p
                  className="cell py-2 px-4"
                  style={{ textAlign: "center", width: "100%" }}
                >
                  No documents are available here.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GetDocumentsbyCategory;
